import { useMemo } from 'react';
import {
    AttributeDefinitionState,
    AttributeValueState,
} from '../../../types/zitoneoServicesTypes';
import { ZitoneoQualityLevel } from '../../../utils/zitoneoContentScoreUtils';

interface AttributeService {
    AttributeDefinitions?: AttributeDefinitionState[];
    AttributeValues?: AttributeValueState[];
}

const useServiceAttributeQuality = (services: AttributeService[]) => {
    const attributesAvailable = services.reduce(
        (total, service) => total + (service.AttributeDefinitions?.length || 0),
        0
    );

    const attributesFilled = services.reduce((total, service) => {
        const definitions = service.AttributeDefinitions || [];
        const values = service.AttributeValues || [];

        return (
            total +
            definitions.reduce((filled, definition) => {
                const definitionValues = values.filter(
                    value =>
                        value.IdAttributeDefinition ===
                        definition.IdAttributeDefinition
                );
                const hasValue = definitionValues.some(
                    value =>
                        value.Value !== null &&
                        value.Value !== undefined &&
                        String(value.Value).trim() !== ''
                );

                return filled + (hasValue ? 1 : 0);
            }, 0)
        );
    }, 0);

    const contentQualityLevel = useMemo(() => {
        if (attributesAvailable === attributesFilled) {
            return ZitoneoQualityLevel.HIGH;
        }
        if (attributesFilled === 0) {
            return ZitoneoQualityLevel.LOW;
        }
        return ZitoneoQualityLevel.MEDIUM;
    }, [attributesAvailable, attributesFilled]);

    const attributesAreLoading = services.some(
        service => !service.AttributeDefinitions
    );

    return {
        attributesAvailable,
        attributesFilled,
        contentQualityLevel,
        attributesAreLoading,
    };
};

export default useServiceAttributeQuality;
